import * as React from "react";
import * as main from "../../styles/main.module.scss";
import * as about from "../../styles/about.module.scss";
export const About = () => {
  return (
    <section className={about.about}>
      <div className={main.containerFluid}>
        <div className={about.about__imgBlock}>
          <div className={`${about.about__imgItemWrap} ${about.about__imgItemWrapLeft}`}>
            <div className={about.about__imgItem}>
              <p>
                Работаем с детьми всех школьных возрастов, любого стартового уровня
              </p>
            </div>
            <div className={about.about__imgItem}>
              <p>
                В наших кейсах много детей билингвов, живущих в других странах и плохо владеющих русским языком
              </p>
            </div>
          </div>
          <div className={`${about.about__imgItemWrap} ${about.about__imgItemWrapRight}`}>
            <div className={about.about__imgItem}>
              <p>
                Знаем как перезапустить мотивацию в ребенке и разжечь интерес к учебе
              </p>
            </div>
            <div className={about.about__imgItem}>
              <p>
                Мы успешно помогаем компенсировать индивидуальные особенности развития (дисграфия, дислексия, алалии
                разных видов и др.)
              </p>
            </div>
          </div>
          <img
            className={about.about__imgCircle}
            src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/photo-2.png"
            alt={""}
          />
        </div>
        <h2 className={main.titleH2}>
          Мы индивидуально решаем все поставленные задачи <br/>
          исходя из интересов вашего ребёнка
        </h2>
        <div className={about.about__arrowBlock}>
          <div className={`${about.about__arrowContent} ${about.about__arrowContentLeft}`}>
            <p className={about.about__arrowText}>
              После прохождения наших курсов ребёнок <br/>
              может самостоятельно за неделю <br/>
              освоить учебник, а за пару месяцев — <br/>
              годовую школьную программу.
            </p>
            <img
              className={about.about__arrowImg}
              src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/photo-3.png"
              alt={""}
            />
          </div>
          <div className={about.about__arrow}></div>
          <div className={`${about.about__arrowContent} ${about.about__arrowContentRight}`}>
            <img
              className={about.about__arrowImg}
              src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/photo-4.png"
              alt={""}
            />
            <p className={about.about__arrowText}>
              Сможет за один час запомнить <br/>
              100 иностранных слов, что 2,5 раза выше <br/>
              средней скорости взрослого человека
            </p>
          </div>
        </div>
        <a href="#skills" className={`${main.btn} ${about.about__arrowBtn}`}>Подробнее о приобретаемых навыках</a>
      </div>
    </section>
  );
};
